// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('@/views/home'),
        meta: { title: '猛犸直采', keepAlive: false },
        hidden: true
    },
    {
        path: '/about',
        name: '/about',
        component: () => import('@/views/about'),
        hidden: false,
        meta: { title: '关于我们', keepAlive: true }
    },
    {
        path: '/contact',
        name: '/contact',
        component: () => import('@/views/contact'),
        hidden: false,
        meta: { title: '联系我们', keepAlive: true }
    },
    {
        path: '/privacy',
        name: '/privacy',
        component: () => import('@/views/privacy'),
        hidden: false,
        meta: { title: '隐私政策', keepAlive: true }
    },
    {
        path: '/agreement',
        name: '/agreement',
        component: () => import('@/views/agreement'),
        hidden: false,
        meta: { title: '用户协议', keepAlive: true }
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})
//router设置页面标题
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
     document.title = to.meta.title
    }
     next()
    })
export default router